import {
  Button,
  Form,
  Input,
  message,
  Modal,
  Progress,
  Select,
  Upload,
} from 'antd';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { DetenteurEntity } from '../../../../entities/detenteur.entity';
import { ORANGE, PRIMARY, YELLOW } from '../../../../shared/colors';
import {
  addAML,
  addKYC,
  getDetenteurAML,
  getDetenteurKYC,
  updateAML,
  updateKYC,
} from '../../../dashboard/components/Monitor/network';
import { StatusPill, StatusTone } from '../../shared/StatusPill';
import { BASE_MEDIA } from '../../../shared/ApiRoutes';

const Container = styled.div`
  font-family: Poppins-R;
  height: 100%;
  color: var(--mt-text);

  .form-shell {
    display: flex;
    flex-direction: column;
    gap: 14px;
  }

  .form-summary {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 18px;
    padding: 18px;
    border: 1px solid var(--mt-border);
    border-radius: 12px;
    background: linear-gradient(135deg, ${PRIMARY}, var(--mt-surface-strong));
    color: #fff;
    box-shadow: 0 18px 44px rgba(2, 8, 12, 0.14);
  }

  .eyebrow {
    display: block;
    color: ${YELLOW};
    font-family: Poppins-B;
    font-size: 11px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }

  h2,
  h3,
  p {
    margin: 0;
  }

  h2 {
    margin-top: 4px;
    font-family: Poppins-B;
    font-size: 22px;
  }

  .summary-main p {
    max-width: 520px;
    margin-top: 6px;
    color: rgba(255, 255, 255, 0.72);
    font-size: 13px;
    line-height: 1.5;
  }

  .summary-metrics {
    display: grid;
    grid-template-columns: repeat(3, minmax(120px, 1fr));
    gap: 10px;
    min-width: 430px;
  }

  .metric {
    padding: 12px;
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.06);
  }

  .metric span {
    display: block;
    color: rgba(255, 255, 255, 0.62);
    font-size: 11px;
    text-transform: uppercase;
  }

  .metric strong {
    display: block;
    margin-top: 6px;
    color: #fff;
    font-family: Poppins-B;
    font-size: 15px;
  }

  .progress-panel,
  .form-section {
    border: 1px solid var(--mt-border);
    border-radius: 12px;
    background: var(--mt-card);
  }

  .progress-panel {
    padding: 14px 16px;
  }

  .progress-copy {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 10px;
    font-family: Poppins-B;
    font-size: 13px;
  }

  .progress-copy span {
    color: var(--mt-muted);
    font-family: Poppins-R;
    font-size: 12px;
  }

  .form-section {
    padding: 16px;
  }

  .section-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 14px;
    border-bottom: 1px solid var(--mt-border);
    padding-bottom: 11px;
  }

  .section-head h3 {
    color: ${YELLOW};
    font-family: Poppins-B;
    font-size: 15px;
    text-transform: uppercase;
  }

  .section-head span {
    color: var(--mt-muted);
    font-size: 12px;
  }

  .field-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 12px;
  }

  .field-grid.two {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .field {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .field.full {
    grid-column: 1 / -1;
  }

  .field label,
  .upload-card label {
    color: var(--mt-muted);
    font-family: Poppins-B;
    font-size: 11px;
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }

  .ant-input,
  .ant-select-selector,
  textarea.ant-input {
    min-height: 38px;
    border-color: var(--mt-border) !important;
    border-radius: 9px !important;
    background: var(--mt-surface) !important;
    color: var(--mt-text) !important;
    box-shadow: none !important;
  }

  .ant-select-selection-item,
  .ant-select-selection-placeholder {
    color: var(--mt-text) !important;
  }

  .ant-input::placeholder,
  textarea.ant-input::placeholder {
    color: color-mix(in srgb, var(--mt-muted) 68%, transparent);
  }

  .documents-grid {
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    gap: 12px;
  }

  .upload-card {
    display: flex;
    min-height: 158px;
    flex-direction: column;
    gap: 9px;
    justify-content: space-between;
    padding: 12px;
    border: 1px solid var(--mt-border);
    border-radius: 11px;
    background: var(--mt-surface);
  }

  .upload-preview {
    display: grid;
    min-height: 58px;
    place-items: center;
    overflow: hidden;
    border: 1px dashed var(--mt-border);
    border-radius: 9px;
    color: var(--mt-muted);
    font-size: 12px;
  }

  .photo {
    width: 100%;
    height: 76px;
    object-fit: cover;
    cursor: zoom-in;
  }

  .document-link {
    color: ${ORANGE};
    font-family: Poppins-B;
  }

  .upload-button {
    width: 100%;
    border-color: color-mix(in srgb, ${ORANGE} 45%, var(--mt-border));
    border-radius: 999px;
    color: ${ORANGE};
    font-family: Poppins-B;
  }

  .form-actions {
    position: sticky;
    bottom: 0;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin: 4px -2px -2px;
    padding: 14px 2px 2px;
    background: linear-gradient(
      180deg,
      color-mix(in srgb, var(--mt-card) 0%, transparent),
      var(--mt-card) 36%
    );
  }

  .ghost-action,
  .primary-action {
    min-width: 140px;
    height: 40px;
    border-radius: 999px;
    font-family: Poppins-B;
  }

  .ghost-action {
    border-color: var(--mt-border);
    background: var(--mt-surface);
    color: var(--mt-text);
  }

  .primary-action {
    border-color: ${ORANGE};
    background: ${ORANGE};
    color: #fff;
    box-shadow: 0 14px 28px color-mix(in srgb, ${ORANGE} 24%, transparent);
  }

  .primary-action:hover,
  .primary-action:focus {
    border-color: ${ORANGE} !important;
    background: ${ORANGE} !important;
    color: #fff !important;
  }

  @media (max-width: 1180px) {
    .form-summary,
    .field-grid,
    .field-grid.two,
    .documents-grid {
      grid-template-columns: 1fr;
    }

    .summary-metrics {
      min-width: 0;
      grid-template-columns: 1fr;
    }
  }
`;

export const KYCForm = ({
  clientToUpdate,
  setShowDrawer,
  getNewClient,
}: {
  clientToUpdate?: DetenteurEntity;
  setShowDrawer: (b: boolean) => void;
  getNewClient: (part: DetenteurEntity) => void;
}) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [previewImage, setpreviewImage] = useState('');
  const [isModalVisible, setIsModalVisible] = useState(false);

  const handleInput = (e) => {
    const { name, value } = e.target;
    const updated = { ...formData, [name]: value };
    setFormData(updated);
    updateProgress(updated, files);
  };

  const [formData, setFormData] = useState({
    full_name: '',
    birth_date: '',
    nationality: '',
    id_type: '',
    id_number: '',
    address: '',
    employment_status: '',
    income_level: '',
    investment_purpose: '',
    politically_exposed: 'non',
    country_of_residence: '',
  });

  const [files, setFiles] = useState<{ [key: string]: File }>({});

  const handleFile = (name, file) => {
    const updated = { ...files, [name]: file };
    setFiles(updated);
    updateProgress(formData, updated);
  };
  const [completion, setCompletion] = useState(0);

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientToUpdate, form]);

  const [kyc, setKYC] = useState<any>({});
  const [aml, setAML] = useState<any>({});

  const handleSubmit = async () => {
    if (clientToUpdate) {
      setIsLoading(true);
      const data = new FormData();

      // Ajoute les champs texte
      Object.entries(formData).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          data.append(key, value);
        }
      });

      // Ajoute seulement les fichiers nouvellement sélectionnés
      Object.entries(files).forEach(([key, value]) => {
        if (value) {
          data.append(key, value);
        }
      });

      data.append('detenteur', clientToUpdate.id);
      data.append('status', 'verified');

      try {
        if (kyc && kyc.id) {
          await updateKYC(kyc.id, data);
          message.success('Informations KYC mises à jour');
        } else {
          await addKYC(data);
          message.success('KYC soumis avec succès');
        }

        // ajouter le AML
        if (aml && aml.id) {
          const data1 = new FormData();
          data1.append('income_level', formData.income_level);
          data1.append('country_of_residence', formData.country_of_residence);
          data1.append('is_pep', formData.politically_exposed);
          data1.append('detenteur', clientToUpdate.id);
          await updateAML(aml.id, data1);
        } else {
          const data1 = new FormData();
          data1.append('income_level', formData.income_level);
          data1.append('country_of_residence', formData.country_of_residence);
          data1.append('is_pep', formData.politically_exposed);
          data1.append('detenteur', clientToUpdate.id);
          await addAML(data1);
        }

        await fetchData(); // Recharge les données
      } catch (error) {
        message.error('Erreur lors de la soumission');
      }

      setIsLoading(false);
    }
  };

  const fetchData = async () => {
    setIsLoading(true);
    if (clientToUpdate) {
      await getDetenteurKYC(clientToUpdate.id).then(async ({ data }) => {
        setKYC(data);
        if (data.error) {
          if (data.error === 'KYC introuvable') {
          }
        } else {
          setKYC(data);
          // Préremplir les valeurs texte
          setFormData({
            full_name: data.full_name || '',
            birth_date: data.birth_date ? data.birth_date.slice(0, 10) : '',
            nationality: data.nationality || '',
            id_type: data.id_type || '',
            id_number: data.id_number || '',
            address: data.address || '',
            employment_status: data.employment_status || '',
            income_level: data.income_level || '',
            investment_purpose: data.investment_purpose || '',
            politically_exposed:
              typeof data.politically_exposed === 'boolean'
                ? data.politically_exposed
                : false,
            country_of_residence: data.country_of_residence || '',
          });

          await preloadFilesFromKYC(data, setFiles);
          updateProgress(data, {});
        }
      });
      await getDetenteurAML(clientToUpdate.id).then(async ({ data }) => {
        setAML(data);
        if (data.error) {
          if (data.error === 'AML introuvable') {
          }
        } else {
          setAML(data);
        }
      });
    }

    setIsLoading(false);
  };

  const preloadFilesFromKYC = async (kycData, setFiles) => {
    const fileKeys = [
      'id_document_front',
      'id_document_back',
      'selfie',
      'proof_of_residency',
    ];

    for (const key of fileKeys) {
      const fileUrl = kycData[key];
      if (fileUrl) {
        try {
          const response = await fetch(BASE_MEDIA + fileUrl);
          const blob = await response.blob();

          const fileExtension = fileUrl.split('.').pop();
          const filename = `${key}.${fileExtension}`;

          const file = new File([blob], filename, { type: blob.type });

          setFiles((prev) => ({
            ...prev,
            [key]: file,
          }));
        } catch (error) {
          console.error(`Erreur lors du chargement du fichier ${key}`, error);
        }
      }
    }
  };

  const showModal = (val) => {
    setIsModalVisible(true);
    setpreviewImage(val);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const updateProgress = (data, fileData) => {
    const totalFields = 14;
    let filled = 0;
    Object.values(data).forEach((val) => {
      if (val && val !== '') filled++;
    });
    Object.values(fileData).forEach((val) => {
      if (val) filled++;
    });
    const percent = Math.min(Math.round((filled / totalFields) * 100), 100);
    setCompletion(percent);
  };

  const renderImageUpload = (name: string, label: string, alt: string) => (
    <div className='upload-card'>
      <label>{label}</label>
      <div className='upload-preview'>
        {kyc[name] ? (
          <img
            src={BASE_MEDIA + kyc[name]}
            className='photo'
            alt={alt}
            onClick={() => showModal(BASE_MEDIA + kyc[name])}
          />
        ) : (
          <span>Document manquant</span>
        )}
      </div>
      <Upload
        accept='image/*'
        beforeUpload={(file) => {
          const isImage = file.type.startsWith('image/');
          if (!isImage) {
            message.error('Seules les images sont autorisées');
            return Upload.LIST_IGNORE;
          }

          handleFile(name, file);
          return false;
        }}
        showUploadList={false}
      >
        <Button className='upload-button'>Téléverser</Button>
      </Upload>
    </div>
  );

  const renderFileUpload = (name: string, label: string) => (
    <div className='upload-card'>
      <label>{label}</label>
      <div className='upload-preview'>
        {kyc[name] ? (
          <a
            href={BASE_MEDIA + kyc[name]}
            target='_blank'
            className='document-link'
            rel='noopener noreferrer'
          >
            Voir le fichier
          </a>
        ) : (
          <span>Document manquant</span>
        )}
      </div>
      <Upload
        beforeUpload={(file) => {
          handleFile(name, file);
          return false;
        }}
        showUploadList={false}
      >
        <Button className='upload-button'>Téléverser</Button>
      </Upload>
    </div>
  );

  return (
    <Container>
      <div className='form-shell'>
        <section className='form-summary'>
          <div className='summary-main'>
            <span className='eyebrow'>Dossier conformité</span>
            <h2>{getClientName(clientToUpdate)}</h2>
            <p>
              Centralisez l'identité, les pièces justificatives et les signaux
              AML avant validation opérationnelle.
            </p>
          </div>
          <div className='summary-metrics'>
            <div className='metric'>
              <span>Statut KYC</span>
              <strong>
                <StatusPill tone={getKycStatusTone(kyc.status)}>
                {getKycStatusLabel(kyc.status)}
                </StatusPill>
              </strong>
            </div>
            <div className='metric'>
              <span>Score AML</span>
              <strong>{aml.aml_risk_score || '-'}</strong>
            </div>
            <div className='metric'>
              <span>Niveau AML</span>
              <strong>
                <StatusPill tone={getAmlRiskTone(aml.aml_risk_level)}>
                  {aml.aml_risk_level || 'Non calculé'}
                </StatusPill>
              </strong>
            </div>
          </div>
        </section>

        <section className='progress-panel'>
          <div className='progress-copy'>
            <strong>Complétude du dossier</strong>
            <span>{completion}% des éléments requis</span>
          </div>
          <Progress
            percent={completion}
            size='small'
            strokeColor={completion === 100 ? '#00a967' : ORANGE}
            status={completion === 100 ? 'success' : 'active'}
          />
        </section>

        <section className='form-section'>
          <div className='section-head'>
            <h3>Identité & résidence</h3>
            <span>Données civiles du détenteur</span>
          </div>
          <div className='field-grid'>
            <div className='field'>
              <label>Date de naissance</label>
              <Input
                type='date'
                name='birth_date'
                value={formData.birth_date}
                onChange={handleInput}
              />
            </div>
            <div className='field'>
              <label>Nationalité</label>
              <Input
                name='nationality'
                placeholder='Nationalité'
                value={formData.nationality}
                onChange={handleInput}
              />
            </div>
            <div className='field'>
              <label>Pays de résidence</label>
              <Input
                name='country_of_residence'
                placeholder='Pays de résidence'
                value={formData.country_of_residence}
                onChange={handleInput}
              />
            </div>
            <div className='field'>
              <label>Type de pièce</label>
              <Input
                name='id_type'
                placeholder='CNI, passeport...'
                value={formData.id_type}
                onChange={handleInput}
              />
            </div>
            <div className='field'>
              <label>Numéro de pièce</label>
              <Input
                name='id_number'
                placeholder='Numéro de pièce'
                value={formData.id_number}
                onChange={handleInput}
              />
            </div>
            <div className='field'>
              <label>Adresse complète</label>
              <Input
                name='address'
                placeholder='Adresse complète'
                value={formData.address}
                onChange={handleInput}
              />
            </div>
          </div>
        </section>

        <section className='form-section'>
          <div className='section-head'>
            <h3>Documents</h3>
            <span>Contrôles visuels et justificatifs</span>
          </div>
          <div className='documents-grid'>
            {renderImageUpload(
              'id_document_front',
              'Pièce recto',
              'Document recto',
            )}
            {renderImageUpload(
              'id_document_back',
              'Pièce verso',
              'Document verso',
            )}
            {renderImageUpload('selfie', 'Selfie', 'Selfie')}
            {renderFileUpload('proof_of_residency', 'Justif. domicile')}
            {renderFileUpload('proof_of_revenue', 'Justif. revenu')}
          </div>
        </section>

        <section className='form-section'>
          <div className='section-head'>
            <h3>Profil financier & AML</h3>
            <span>Usage prévu, revenus et exposition politique</span>
          </div>
          <div className='field-grid two'>
            <div className='field'>
              <label>Profession</label>
              <Input
                name='employment_status'
                placeholder='Profession'
                value={formData.employment_status}
                onChange={handleInput}
              />
            </div>
            <div className='field'>
              <label>Objectif d'investissement</label>
              <Input
                name='investment_purpose'
                placeholder="Objectif d'investissement"
                value={formData.investment_purpose}
                onChange={handleInput}
              />
            </div>
            <div className='field'>
              <label>Personne politiquement exposée</label>
              <Select
                value={formData.politically_exposed}
                onChange={(value) =>
                  setFormData((prev) => ({
                    ...prev,
                    politically_exposed: value,
                  }))
                }
                options={[
                  { label: 'Oui', value: true },
                  { label: 'Non', value: false },
                ]}
              />
            </div>
            <div className='field'>
              <label>Revenu</label>
              <Select
                value={formData.income_level}
                onChange={(value) =>
                  setFormData((prev) => ({
                    ...prev,
                    income_level: value,
                  }))
                }
                options={[
                  { value: 'Non déclaré', label: 'Non déclaré' },
                  {
                    value: 'Faible',
                    label: 'Faible (< 100 000 XAF/mois)',
                  },
                  {
                    value: 'Moyen',
                    label: 'Moyen (100 000 à 500 000 XAF/mois)',
                  },
                  {
                    value: 'Élevé',
                    label: 'Élevé (> 500 000 XAF/mois)',
                  },
                  {
                    value: 'Très élevé',
                    label: 'Très élevé (> 1 000 000 XAF/mois)',
                  },
                ]}
              />
            </div>
          </div>
        </section>

        <div className='form-actions'>
          <Button
            className='ghost-action'
            onClick={() => setShowDrawer(false)}
          >
            Fermer
          </Button>
          <Button
            onClick={handleSubmit}
            loading={isLoading}
            className='primary-action'
          >
            {kyc && kyc.id ? 'Mettre à jour' : 'Soumettre'}
          </Button>
        </div>
      </div>
      <Modal
        open={isModalVisible}
        onCancel={handleCancel}
        footer={null}
        centered
      >
        <img
          src={previewImage}
          alt='Aperçu agrandi'
          style={{ width: '100%' }}
        />
      </Modal>
    </Container>
  );
};

const getClientName = (client?: DetenteurEntity) => {
  const fullName = [client?.nom, client?.prenom].filter(Boolean).join(' ');
  return fullName || 'Client à qualifier';
};

const getKycStatusTone = (status?: string): StatusTone => {
  if (status === 'verified') return 'success';
  if (status === 'rejected') return 'danger';
  if (status === 'submitted' || status === 'pending') return 'warning';
  return 'neutral';
};

const getKycStatusLabel = (status?: string) => {
  if (status === 'verified') return 'Vérifié';
  if (status === 'submitted') return 'Soumis';
  if (status === 'pending') return 'En attente';
  if (status === 'rejected') return 'Rejeté';
  return 'Non soumis';
};

const getAmlRiskTone = (risk?: string): StatusTone => {
  const normalizedRisk = risk?.toLowerCase();
  if (normalizedRisk === 'faible') return 'success';
  if (normalizedRisk === 'moyen') return 'warning';
  if (normalizedRisk === 'eleve' || normalizedRisk === 'élevé') return 'danger';
  return 'neutral';
};
